import { TopRightMenu } from '../NavMenus/TopNavigation';
import Logo from '../Common/Logo';

export default function Header({
  children: heroContent,
  showNavbar = true,
}: {
  children?: React.ReactNode;
  showNavbar?: boolean;
}) {
  const navbar = showNavbar ? (
    <div
      className="header-content site-header home-header-bar header-gradient home-header-bar-scrolled"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1002,
        backgroundColor: '#ffffff',
      }}
    >
      <Logo />
      <TopRightMenu renderizedBy="ApplyPage" />
    </div>
  ) : null;

  return (
    <>
      {navbar}
      <section className={`home-header${showNavbar ? ' home-header--with-nav' : ''}`}>
        <div className="overlay-content home-hero-overlay">
          {heroContent != null ? (
            <div className="home-hero-content">{heroContent}</div>
          ) : (
            <h1 className="custom-slogan gradient-color text-center">DATA FOR TOMORROW'S HEALTH</h1>
          )}
        </div>
      </section>
    </>
  );
}
